import { useState, useEffect } from "react";
import { useSearchParams } from "react-router-dom";
import SubscriptionPromo from "../components/SubscriptionPromo";
import { API } from "../config";

export default function Subscription() {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [notice, setNotice] = useState("");
  const [searchParams] = useSearchParams();

  useEffect(() => {
    if (searchParams.get("success")) setNotice("Subscription activated. Welcome to Tailor Inc. Preferred.");
    else if (searchParams.get("canceled")) setError("Checkout was canceled. No charge was made.");
  }, [searchParams]);

  async function go() {
    setLoading(true);
    setError("");
    try {
      const r = await fetch(`${API}/subscribe`, { method: "POST" });
      const data = await r.json();
      if (!r.ok || !data.url) throw new Error(data.detail || data.error || "Checkout unavailable");
      window.location.href = data.url;
    } catch (e) {
      setError(e.message || "Unable to start checkout");
      setLoading(false);
    }
  }

  return (
    <main className="shell inner">
      <p className="eyebrow">TAILOR INC. PREFERRED SUBSCRIPTION</p>
      <h1 className="page-title">Tailoring, on your terms.</h1>
      <p className="lead darklead">A wardrobe care subscription for people who appreciate the difference a perfect fit makes.</p>
      <SubscriptionPromo />
      <div className="subscribe-bottom">
        <h2>Join for $29.99/month</h2>
        <p>Monthly recurring subscription. Cancel future renewals. Your mobile fitting reservation is separate.</p>
        <button className="button gold" disabled={loading} onClick={go} data-testid="subscribe-btn">
          {loading ? "Opening secure checkout…" : "Subscribe Securely — $29.99/Month"}
        </button>
        {error && <p role="alert" className="error" data-testid="subscribe-error">{error}</p>}
        {notice && <p role="status" className="form-message" data-testid="subscribe-notice">{notice}</p>}
      </div>
      <section className="section">
        <h2>Subscription details</h2>
        <div className="terms">
          <p>Two eligible QuickFit alterations are available per calendar quarter, subject to service eligibility and appointment availability. Unused benefits do not carry forward and cannot be transferred. Subscriber discounts apply only to eligible additional alteration labor. Quarterly promotions and other discounts cannot be stacked on the same service. Final garment eligibility and pricing are determined at fitting.</p>
          <p>Illustrative savings do not guarantee a particular amount saved. A $100 private fitting reservation remains separate from the subscription and is credited to eligible alteration labor. After-hours fittings carry an additional $50 noncreditable convenience fee. Subscription renews monthly until canceled; cancellation stops future renewals and does not automatically refund prior charges.</p>
          <p>Subscription benefits are verified against active payment status and applied by Tailor Inc. at the time of service. This website does not automatically calculate garment-level subscription discounts during checkout.</p>
        </div>
      </section>
    </main>
  );
}
